<section>
  <!-- COMPONENT -->
  <ng-container *ngIf="!show.loadingState">
    <div class="vertical-container-simple column-gap-1">

      <!-- Dilution %, by stage (past 24 month)  -->
      <div class="main row-container row-gap-1">
        <div class="vertical-container-simple column-gap-1 width-50pcnt">
          <div class="font-2 bold600">Dilution %, by stage (past 24 month)</div>
          <div class="flex-grow-1">
            <app-ma-by-industry-dilution-table
              data-qa="ma-by-ind-dilution-table"
              [data]="byIndustryData.dilution.table">
            </app-ma-by-industry-dilution-table>
          </div>
        </div>
        <div class="width-50pcnt">
          <app-base-bar-chart
            data-qa="ma-by-ind-dilution-chart"
            [chartId]="'ma-by-ind-dilution-chart'"
            [height]="'height-22'"
            [additionalOptions]="chartsOptions.dilution">
          </app-base-bar-chart>
        </div>
      </div>

      <!-- # of deals, by stage (past 24 month)  -->
      <div class="main vertical-container-simple column-gap-1">
        <div class="font-2 bold600"># of deals, by stage (past 24 month)</div>
        <app-base-bar-chart
          data-qa="ma-by-ind-number-of-deals-chart"
          [chartId]="'ma-by-ind-number-of-deals-chart'"
          [additionalOptions]="chartsOptions.numberOfDeals">
        </app-base-bar-chart>
      </div>

      <!-- Total raised, per industry  -->
      <div class="main vertical-container-simple column-gap-1">
        <div class="font-2 bold600">Total raised, per industry</div>

        <!-- Total raised, per industry - CHARTS-->
        <div class="space-between-horizontal row-gap-1">
          <div  *ngIf="chartsOptions.raisedByIndustry.year1" class="vertical-container-simple column-gap-1 padding-1 width-49pcnt bordered">
            <div>
              <span class="font-2 bold600">{{RAISED_BY_INDUSTRY_TITLE_FIRST_PART}}</span>
              <span data-qa="ma-raised-by-ind-year-title-1" class="font-2 bold600 main-8">{{selected.period}}</span>
            </div>
            <app-base-pie-chart data-qa="ma-raised-by-ind-year-chart-1" [chartId]="'pie-chart-year1'" [additionalOptions]="chartsOptions.raisedByIndustry.year1"></app-base-pie-chart>
          </div>
          <div *ngIf="chartsOptions.raisedByIndustry.year2" class="vertical-container-simple column-gap-1 padding-1 width-49pcnt bordered">
            <div>
              <span class="font-2 bold600">{{RAISED_BY_INDUSTRY_TITLE_FIRST_PART}}</span>
              <span data-qa="ma-raised-by-ind-year-title-2" class="font-2 bold600 main-8">{{previousYears.year1}}</span>
            </div>
            <app-base-pie-chart data-qa="ma-raised-by-ind-year-chart-2" [chartId]="'pie-chart-year2'" [additionalOptions]="chartsOptions.raisedByIndustry.year2"></app-base-pie-chart>
          </div>
        </div>
      </div>

      <!-- Number of deals, per industry  -->
      <div class="main vertical-container-simple column-gap-1">
        <div class="font-2 bold600">% of deals, per industry</div>
        <div class="space-between-horizontal row-gap-1">
          <div  *ngIf="chartsOptions.numberOfDealsPerIndustry.year1" class="vertical-container-simple column-gap-1 padding-1 width-49pcnt bordered">
            <div>
              <span class="font-2 bold600">{{RAISED_BY_INDUSTRY_TITLE_FIRST_PART}}</span>
              <span data-qa="ma-num-deals-year-title-1" class="font-2 bold600 main-8">{{selected.period}}</span>
            </div>
            <app-base-pie-chart data-qa="ma-num-deals-year-chart-1" [chartId]="'number-of-deals-per-industry-year-1'" [additionalOptions]="chartsOptions.numberOfDealsPerIndustry.year1"></app-base-pie-chart>
          </div>
          <div *ngIf="chartsOptions.numberOfDealsPerIndustry.year2" class="vertical-container-simple column-gap-1 padding-1 width-49pcnt bordered">
            <div>
              <span class="font-2 bold600">{{RAISED_BY_INDUSTRY_TITLE_FIRST_PART}}</span>
              <span data-qa="ma-num-deals-year-title-2" class="font-2 bold600 main-8">{{previousYears.year1}}</span>
            </div>
            <app-base-pie-chart data-qa="ma-num-deals-year-chart-2" [chartId]="'number-of-deals-per-industry-year-2'" [additionalOptions]="chartsOptions.numberOfDealsPerIndustry.year2"></app-base-pie-chart>
          </div>
        </div>
      </div>

      <!--  Top 5 industries    -->
      <div class="main flex flex-col gap-0.9375 h-[47rem]">
        <div class="flex items-center gap-0.3125">
          <div class="font-2 bold600">Top 5 industries by</div>
          <app-button [size]="'small'" [type]="show.topFiveSection.capitalRaised ? 'accent' : 'default'" (buttonClick)="selectChart(MaSections.MA_BY_IND_TOP_FIVE, MaSelectedCharts.MA_BY_IND_TOP_FIVE_CAPITAL_RAISED)">capital raised</app-button>
          <app-button [size]="'small'" [type]="show.topFiveSection.numberOfDeals ? 'accent' : 'default'" (buttonClick)="selectChart(MaSections.MA_BY_IND_TOP_FIVE, MaSelectedCharts.MA_BY_IND_TOP_FIVE_NUM_DEALS)"># of deals</app-button>
        </div>
        <app-base-bar-chart *ngIf="show.topFiveSection.capitalRaised" data-qa="ma-top-5-ind-capital-raised" [chartId]="'ma-top-5-ind-capital-raised'" [additionalOptions]="chartsOptions.topFiveIndustries.capitalRaised"/>
        <app-base-bar-chart *ngIf="show.topFiveSection.numberOfDeals" data-qa="ma-top-5-ind-num-of-deals" [chartId]="'ma-top-5-ind-num-of-deals'" [additionalOptions]="chartsOptions.topFiveIndustries.numberOfDeals"/>
        <app-ma-top-five-industries-table
          [data]="byIndustryData.topFiveIndustries"
          [chartType]="show.topFiveSection.numberOfDeals ? 'numberOfDeals' : 'capitalRaised'"/>
      </div>

    </div>
  </ng-container>

  <!-- EMPTY STATE -->
  <ng-container *ngIf="show.loadingState">
    <div class="vertical-container-simple column-gap-1">

      <!-- Dilution %, by stage (past 24 month)  -->
      <div class="main vertical-container-simple column-gap-1">
        <div class="font-2 bold600">Dilution %, by stage (past 24 month)</div>
        <div class="space-between-horizontal row-gap-1">
          <app-standard-skeleton-table class="width-49pcnt"
           [headers]="['Up to post', '% of deals', 'Avg. round', 'Avg. post', 'Dilution, %']"
           [tdAmount]="5"
           [trAmount]="7">
          </app-standard-skeleton-table>
          <div class="vertical-container-simple column-gap-1 width-49pcnt">
            <div class="width-100pcnt height-20 bg-black-3 br-0p5"></div>
          </div>
        </div>
      </div>

      <!-- # of deals, by stage (past 24 month)  -->
      <div class="main vertical-container-simple column-gap-1">
        <div class="font-2 bold600"># of deals, by stage (past 24 month)</div>
        <div class="width-100pcnt height-28 bg-black-3 br-0p5"></div>
      </div>

      <!-- Total raised, per industry  -->
      <div class="main vertical-container-simple column-gap-1 height-34p5">
        <div class="font-2 bold600">Total raised, per industry</div>
        <div class="space-between-horizontal row-gap-1 height-30">
          <div class="vertical-container-simple column-gap-1 padding-1 width-49pcnt bordered">
            <div class="width-50pcnt height-1 bg-black-3 br-0p5"></div>
            <div class="width-100pcnt height-27 bg-black-3 br-0p5"></div>
          </div>
          <div class="vertical-container-simple column-gap-1 padding-1 width-49pcnt bordered">
            <div class="width-50pcnt height-1 bg-black-3 br-0p5"></div>
            <div class="width-100pcnt height-27 bg-black-3 br-0p5"></div>
          </div>
        </div>
      </div>

      <!-- % of deals, per industry  -->
      <div class="main vertical-container-simple column-gap-1 height-34p5">
        <div class="font-2 bold600">% of deals, per industry</div>
        <div class="space-between-horizontal row-gap-1 height-30">
          <div class="vertical-container-simple column-gap-1 padding-1 width-49pcnt bordered">
            <div class="width-50pcnt height-1 bg-black-3 br-0p5"></div>
            <div class="width-100pcnt height-27 bg-black-3 br-0p5"></div>
          </div>
          <div class="vertical-container-simple column-gap-1 padding-1 width-49pcnt bordered">
            <div class="width-50pcnt height-1 bg-black-3 br-0p5"></div>
            <div class="width-100pcnt height-27 bg-black-3 br-0p5"></div>
          </div>
        </div>
      </div>

      <!-- Top 5 industries  -->
      <div class="main flex flex-col gap-0.9375 h-[47rem]">
        <div class="flex items-center gap-0.3125">
          <div class="font-2 bold600">Top 5 industries by</div>
          <app-button [size]="'small'" [type]="'accent'">capital raised</app-button>
          <app-button [size]="'small'" [type]="'default'"># of deals</app-button>
        </div>
        <div class="width-100pcnt height-28 bg-black-3 br-0p5"></div>
        <app-standard-skeleton-table
         [headers]="['Industry', '', '', '', '', '', '', '', '']"
         [tdAmount]="9"
         [trAmount]="5">
        </app-standard-skeleton-table>
      </div>
    </div>
  </ng-container>
</section>
